var map = {
	"./assets/cases_bg.jpg": 3275,
	"./assets/company_bg.png": 3417,
	"./assets/engineeringCase/古青高速公路白芨滩服务区加油站装饰装修.png": 4088,
	"./assets/engineeringCase/吴忠市红寺堡区第六幼儿园建设项目.png": 8667,
	"./assets/engineeringCase/吴忠市红寺堡区第六幼儿园建设项目（1）.png": 5121,
	"./assets/engineeringCase/吴忠监狱改扩建项目.png": 8961,
	"./assets/engineeringCase/吴忠监狱改扩建项目（2）.png": 6722,
	"./assets/engineeringCase/国网宁夏信通公司生产综合用房项目.png": 5691,
	"./assets/engineeringCase/大武口星海镇养老护理院项目.png": 8082,
	"./assets/engineeringCase/大武口星海镇养老护理院项目（1）.png": 546,
	"./assets/engineeringCase/彭阳县改建第六小学（白阳镇寄宿制小学）项目.png": 4481,
	"./assets/engineeringCase/彭阳县改建第六小学（白阳镇寄宿制小学）项目（1）.png": 1395,
	"./assets/engineeringCase/德胜滨河路生态运动公园绿化项目.png": 5976,
	"./assets/engineeringCase/德胜滨河路生态运动公园绿化项目（1）.png": 4756,
	"./assets/engineeringCase/欣益巷（宣和巷-朔方路）道路工程.png": 3968,
	"./assets/engineeringCase/苦水河（吴忠市同心县段）防洪治理工程.png": 426,
	"./assets/engineeringCase/苦水河（吴忠市同心县段）防洪治理工程（1）.png": 5626,
	"./assets/engineeringCase/西吉县旧城区综合治理项目.png": 9580,
	"./assets/engineeringCase/西吉县旧城区综合治理项目（1）.png": 4448,
	"./assets/font/ysbth.ttf": 9483,
	"./assets/home_bottom_bg.jpg": 1825,
	"./assets/home_fm.png": 5149,
	"./assets/honorsAndQualifications/2017年自信A级.jpg": 8742,
	"./assets/honorsAndQualifications/2018年优秀施工队伍.png": 8510,
	"./assets/honorsAndQualifications/2020年石嘴山市先进会员单位.jpg": 8564,
	"./assets/honorsAndQualifications/2021年度宁夏建筑业联合会先进会员单位.jpg": 3676,
	"./assets/honorsAndQualifications/2021年银川市先进会员单位.jpg": 9122,
	"./assets/honorsAndQualifications/2022年度联合会先进会员单位奖牌.jpg": 3600,
	"./assets/honorsAndQualifications/2024.6.21全二级资质证书 - 副本.jpg": 7418,
	"./assets/honorsAndQualifications/2024.6.21最新劳务资质证书.jpg": 7343,
	"./assets/honorsAndQualifications/2024年6月最新三体系证书 质量管理.png": 9481,
	"./assets/honorsAndQualifications/2024年6月最新三体系证书环境管理.png": 1116,
	"./assets/honorsAndQualifications/2024年6月最新三体系证书职业健康.png": 5177,
	"./assets/honorsAndQualifications/21年石嘴山先进会员单位奖牌.png": 4287,
	"./assets/honorsAndQualifications/22年度石嘴山先进会员单位奖牌.jpg": 9166,
	"./assets/honorsAndQualifications/22年技能大赛奖牌.jpg": 7942,
	"./assets/honorsAndQualifications/23年技能大赛奖牌-自治区.png": 4071,
	"./assets/honorsAndQualifications/23年技能大赛奖牌-银川市.png": 3121,
	"./assets/honorsAndQualifications/3A奖牌.png": 1957,
	"./assets/honorsAndQualifications/中石油HSE认证证书 (1).jpg": 518,
	"./assets/honorsAndQualifications/压力管道资质副本.jpg": 8848,
	"./assets/honorsAndQualifications/宁夏银行2016A+级证书.jpg": 3314,
	"./assets/honorsAndQualifications/安防证.jpg": 5502,
	"./assets/honorsAndQualifications/承装修试三级.png": 9304,
	"./assets/honorsAndQualifications/林草种子电子证.jpg": 2906,
	"./assets/honorsAndQualifications/水利3A证书.png": 239,
	"./assets/honorsAndQualifications/自治区和谐劳动关系奖牌.jpg": 3999,
	"./assets/honorsAndQualifications/道路运输许可证.jpg": 3272,
	"./assets/honorsAndQualifications/银川22年度先进会员单位奖牌.jpg": 8415,
	"./assets/honorsAndQualifications/银川市2016-2017年度守合同重信用.jpg": 5864,
	"./assets/honorsAndQualifications/银川市农民工工资诚信支付承诺企业.jpg": 7283,
	"./assets/honorsAndQualifications/银川市副会长单位.jpg": 5030,
	"./assets/logo.png": 3153,
	"./assets/map.png": 12,
	"./assets/other/contact_logo.jpg": 7819,
	"./assets/other/other_bg.jpg": 3601,
	"./assets/other/other_logo.png": 850,
	"./assets/qualification/qualification1.png": 1150,
	"./assets/qualification/qualification10.png": 4284,
	"./assets/qualification/qualification2.png": 8501,
	"./assets/qualification/qualification3.png": 9404,
	"./assets/qualification/qualification4.png": 9571,
	"./assets/qualification/qualification5.png": 1994,
	"./assets/qualification/qualification6.png": 2161,
	"./assets/qualification/qualification7.png": 4296,
	"./assets/qualification/qualification8.png": 6559,
	"./assets/qualification/qualification9.png": 230,
	"./assets/work_type1.jpg": 6435,
	"./assets/work_type2.jpg": 372,
	"./assets/work_type3.jpg": 2177,
	"./assets/work_type4.jpg": 6946
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5353;